import { defineRouting } from 'next-intl/routing';

import { defaultLocale, locales } from './constants';

const getDomainFromHostUrl = (url = 'https://joi.com') =>
	url.replace(/^https?:\/\//, '');

export const routing = defineRouting({
	locales,
	defaultLocale,
	localePrefix: 'never',
	domains: locales.map((locale) => ({
		domain: `${
			locale === defaultLocale ? `` : `${locale}.`
		}${getDomainFromHostUrl(process.env.APP_HOST_URL)}`,
		defaultLocale: locale,
		locales: [locale],
	})),
	localeDetection: true,
});
